import { type Registry as Services, service } from '@ember/service';
import type Transition from '@ember/routing/transition';
import PermittedRoute from 'uplisting-frontend/pods/base/permitted-route';
import {
  scrollRhsToTop,
  loadAiSettingsIfPermitted,
} from 'uplisting-frontend/pods/-sidebar/utils';
import CalendarEnquiriesController from 'uplisting-frontend/pods/xcalendar/enquiries/controller';

interface IParams extends Record<string, unknown> {
  enquiry_id: string;
}

export default abstract class SidebarEnquiriesRoute extends PermittedRoute {
  @service features!: Services['features'];

  permission = 'calendar.enquiries';

  async model(params: IParams) {
    const [enquiry] = await Promise.all([
      this.store.findRecord('enquiry', params.enquiry_id, {
        reload: true,
        include: this.include,
      }),
      loadAiSettingsIfPermitted(this),
    ]);

    return enquiry;
  }

  private get include(): string {
    const include = ['channel_user', 'property', 'ai_occasion_context'];

    if (this.features.isInboxAssignmentEnabled) {
      include.push('inbox_message');
    }

    return include.join(',');
  }

  setupController(
    controller: CalendarEnquiriesController,
    model,
    transition: Transition,
  ): void {
    super.setupController(controller, model, transition);

    Object.assign(controller, { enquiry: model });

    scrollRhsToTop(this);
  }
}
